import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../../../styles/constants/colors";
import { FONTS } from "../../../../styles/constants/fonts";

export const useStyles = makeStyles({
  basic: {
    color: COLORS.PRIMARY,
    fontFamily: FONTS.PRIMARY,
    backgroundColor: "#fff",
    border: 0,
    borderRadius: "2px",
    fontSize: "13px",
    margin: "0px",
    height: "36px",
    padding: "1px 16px",
    transitionDelay: "0s",
    transitionDuration: "350ms",
    transitionProperty: "all",
    transitionTimingFunction: "ease",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      background: "#F8F9FA",
      boxShadow: "none",
    },
    "& + &": {
      marginLeft: '10px',
    }
  },
  colored: {
    backgroundColor: COLORS.PRIMARY,
    color: "#fff",
    "&:hover": {
      backgroundColor: COLORS.DARKCYAN,
    }
  }
});
